import { render, staticRenderFns } from "./Guides.vue?vue&type=template&id=3911f3d8&scoped=true&"
import script from "./Guides.vue?vue&type=script&lang=ts&"
export * from "./Guides.vue?vue&type=script&lang=ts&"
import style0 from "./Guides.vue?vue&type=style&index=0&id=3911f3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3911f3d8",
  null
  
)

export default component.exports